import { IconChevronDown } from '@/components/icons/IconChevronDown';

type VehicleSelectProps = {
    /** The select keeps its name even where the visible word next to it is hidden. */
    ariaLabel: string;
    value: string | number;
    options: readonly { value: string | number; label: string }[];
    onChange: (value: string) => void;
};

/** Compact native select of the toolbar and the pagination, with the design's chevron. */
export function VehicleSelect({ ariaLabel, value, options, onChange }: VehicleSelectProps) {
    return (
        <span className="vehicle-select">
            <select
                aria-label={ariaLabel}
                className="vehicle-select__control label-sm"
                value={value}
                onChange={(event) => onChange(event.target.value)}
            >
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
            <IconChevronDown className="vehicle-select__chevron" aria-hidden="true" />
        </span>
    );
}
